/** The small vocabulary the Open Buffets screens share, kept in one file so no two disagree about the week. */

// 0 = Monday to 6 = Sunday - the backend's convention and the one every RestoBOXX day-picker follows.
export const WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const WEEK_LONG = ['Monday', 'Tuesday', 'Wednesday', 'Thursday',
  'Friday', 'Saturday', 'Sunday'];
export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];

/* JavaScript counts the week from Sunday and we count from Monday, so every conversion goes through here. */
export const monday0 = (d) => (d.getDay() + 6) % 7;

export const rupees = (n) => `Rs ${Math.round(Number(n) || 0).toLocaleString('en-MU')}`;

/* A Date to YYYY-MM-DD in LOCAL time - never toISOString(), which hands back yesterday east of Greenwich. */
export const iso = (d) => d.toLocaleDateString('en-CA');

export const addDays = (isoDate, n) => {
  const d = new Date(`${isoDate}T00:00:00`);
  d.setDate(d.getDate() + n);
  return iso(d);
};

// "14:30" → "2:30 pm", the way every clock in this product reads.
export const t12 = (v) => {
  if (!v) return '';
  const [h, m] = String(v).split(':').map(Number);
  if (Number.isNaN(h)) return v;
  const ap = h < 12 ? 'am' : 'pm';
  const h12 = h % 12 || 12;
  return m ? `${h12}:${String(m).padStart(2, '0')} ${ap}` : `${h12} ${ap}`;
};

export const longDate = (isoDate) => new Date(`${isoDate}T00:00:00`)
  .toLocaleDateString([], { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

export const shortDate = (isoDate) => new Date(`${isoDate}T00:00:00`)
  .toLocaleDateString([], { day: 'numeric', month: 'short' });

export const str = (v) => (v == null ? '' : String(v));

/* Digits and at most one decimal point: what a money or quantity box accepts while it is being typed. */
export const money = (v) => {
  const s = String(v || '').replace(/[^\d.]/g, '');
  const i = s.indexOf('.');
  return i === -1 ? s : s.slice(0, i + 1) + s.slice(i + 1).replace(/\./g, '');
};
